import { ModulesMap, ModulesConfigMap } from '../data/modulesMaps'
import { STORE_MAP } from '@/config/cache/cache-engine'

export default {
	getCrops: {
		useCache: true,
		cacheStorage: STORE_MAP.FULL,
		apiServiceMethodName:
			ModulesConfigMap[ModulesMap.CROPS].GET_CROPS,
	},
	getBasedCrops: {
		useCache: true,
		cacheStorage: STORE_MAP.BASE,
		apiServiceMethodName:
			ModulesConfigMap[ModulesMap.CROPS].GET_CROPS,
	},
	getExtendedCrops: {
		useCache: true,
		cacheStorage: STORE_MAP.EXTENDED,
		apiServiceMethodName:
			ModulesConfigMap[ModulesMap.CROPS].GET_CROPS,
	},
	getCropPreview: {
		apiServiceMethodName:
			ModulesConfigMap[ModulesMap.CROPS].GET_CROP_PREVIEW,
	},
	getCropPopup: {
		apiServiceMethodName:
			ModulesConfigMap[ModulesMap.CROPS].GET_CROP_POPUP,
	},
	getCrop: {
		useCache: true,
		isSingleCachedEntity: true,
		cacheStorage: STORE_MAP.FULL,
		apiServiceMethodName: ModulesConfigMap[ModulesMap.CROPS].GET_CROP,
	},
	createCrop: {
		apiServiceMethodName:
			ModulesConfigMap[ModulesMap.CROPS].CREATE_CROP,
	},
	patchCrop: {
		apiServiceMethodName:
			ModulesConfigMap[ModulesMap.CROPS].PATCH_CROP,
	},
	putCrop: {
		apiServiceMethodName: ModulesConfigMap[ModulesMap.CROPS].PUT_CROP,
	},
	deleteCrop: {
		apiServiceMethodName:
			ModulesConfigMap[ModulesMap.CROPS].DELETE_CROP,
	},
}
